import React, { useState, useEffect } from "react";
import { GiCash } from "react-icons/gi";
import "./Dashboard.css";
import { PieChart } from "react-minimal-pie-chart";
import SliderCrousel from "../../Components/SliderCrousel";
import Header from "../../Components/Header";
import Seo from "../../Components/SeoComponent/Seo";
import ModalWithPinInput from "../../Components/ModalWithPinComponent/DigitalKycAadhar";
import ModalWithPinInputEmail from "../../Components/ModalWithPinComponent/DigitalKycEmail";
import ModalWithPinInputMobile from "../../Components/ModalWithPinComponent/DigitalKycMobile";
import { HiArrowsRightLeft } from "react-icons/hi2";
import { FiPhone } from "react-icons/fi";
import { MdOutlinePayment } from "react-icons/md";
import { AiFillBank } from "react-icons/ai";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { FaReceipt } from "react-icons/fa6";

import AOS from "aos";
import "aos/dist/aos.css";
import {
  showSuccessToast,
  showErrorToast,
  showWarningToast,
} from "../../utils/toastUtils";
import {
  aadharverifyPService,
  fetchProfile,
  verifyEmailSignUp,
  verifyMobile,
  verifyPanService,
} from "../../Services/profile/profileservice";
import AnimateCard from "./AnimateCard";
import { Link } from "react-router-dom";
import { InfoIcon, User2Icon } from "lucide-react";

export default function Dashboard() {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setShowModal] = useState(false);
  const [isModalOpenEmail, setModalOpenEmail] = useState(false);
  const [isModalOpenMobile, setShowModalMobile] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [isPanVerify, setIsPanVerify] = useState(false);
  const [isAadharVerify, setIsAadharVerify] = useState(false);
  const [isMobileVerify, setIsMobileVerify] = useState(false);
  const [isEmailVerify, setIsEmailVerify] = useState(false);
  const [clientID, setClientID] = useState("");
  const [identifier, setIdentifier] = useState("");
  const [mobile, setMobile] = useState("");
  const [aadhar, setAadhar] = useState("");
  const [email, setEmail] = useState("");
  const [showBalance, setShowBalance] = useState(false);
  const accountNumber = profileData?.payout_account?.account_number || "N/A";
  const ifsc = profileData?.payout_account?.ifsc_code || "N/A";
  const balance = parseFloat(profileData?.payout_account?.balance);
  const formattedBalance = !isNaN(balance) ? `₹ ${balance.toFixed(2)}` : "N/A";

  const [walletbal, setWalletBal] = useState(false);
  const walletBalanc = parseFloat(profileData?.balance);
  const formattedwalletbal = !isNaN(walletBalanc)
    ? `₹ ${walletBalanc.toFixed(2)}`
    : "N/A";

  const toggleModal = () => setShowModal(false);

  const toggleModalMobile = () => {
    setShowModalMobile(false);
  };

  const toggleModalEmail = () => setModalOpenEmail(false);

  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);

  // Validate Pan No from profile
  async function validatePan() {
    try {
      setIsPanVerify(true);
      const response = await verifyPanService();

      if (response.status === 422) {
        showErrorToast(response.data.details.message);
        return;
      }

      if (response.status === 200 && response.status.code === 200) {
        showSuccessToast(response.status.message);
      } else {
        showWarningToast("Unexpected response status");
      }
    } catch (error) {
      showWarningToast("Failed to verify PAN");
      console.error("Error during PAN verification:", error);
    } finally {
      setIsPanVerify(false);
    }
  }
  // ENd

  async function validateAadhar() {
    try {
      setIsLoading(true);
      setIsAadharVerify(true);

      const response = await aadharverifyPService();
      const statusCode = response?.status?.code || response?.status;

      // Handle 500 error from server
      if (statusCode === 500) {
        let serverErrorMessage = "Server error. Please try again later.";

        try {
          // Try to parse stringified JSON error message
          const parsedMessage = JSON.parse(response.message);

          if (parsedMessage?.message) {
            serverErrorMessage = parsedMessage.message;
          }
        } catch (err) {
          console.error("Failed to parse server message:", err);
        }

        showErrorToast(serverErrorMessage);
        setIsMobileVerify(false);
        setIsLoading(false);
        return;
      }

      // Handle validation error (422)
      if (statusCode === 422) {
        showErrorToast(
          response.status.message ||
            "Failed to send OTP request or Invalid Aadhar",
        );
        setIsMobileVerify(false);
        setIsLoading(false);
        return;
      }

      // Handle success (200)
      if (statusCode === 200) {
        setIsMobileVerify(false);
        setClientID(response.data.data.client_id);
        setShowModal(true);
        getProfile();
        showSuccessToast(response.status.message);
        setIsLoading(false);
        return;
      }

      // Fallback
      showWarningToast("Unexpected response status");
    } catch (error) {
      setIsMobileVerify(false);
      setIsLoading(false);
      showWarningToast("Failed to verify Aadhar");
      console.error("Aadhar verification error:", error);
    } finally {
      setIsAadharVerify(false);
    }
  }

  //  ENd

  // Validate Mobile No.  from profile
  async function validateMobile() {
    try {
      setIsLoading(true);
      setIsMobileVerify(true);
      const response = await verifyMobile();
      if (response.status === 422) {
        showErrorToast(response.data.status.message);
        setIsMobileVerify(false);
        setIsLoading(false);
        return;
      }
      if (response.status.code === 200) {
        setIsMobileVerify(false);
        setIdentifier(response.identifier);
        setShowModalMobile(true);
        getProfile();
        showSuccessToast(response.status.message);
        setIsLoading(false);
        return;
      }
    } catch (error) {
      setIsMobileVerify(false);
      setIsLoading(false);
      showWarningToast("Failed to verify mobile no");
      return error;
    }
  }
  // ENd

  // Validate Email ID
  async function validateEmail() {
    try {
      setIsLoading(true);
      setIsEmailVerify(true);
      const response = await verifyEmailSignUp();
      const statusCode = response?.status?.code || response?.status;
      //  400 — Email already exists
      if (statusCode === 400) {
        const errorMessage = response?.message || "Email already exists.";
        showErrorToast(errorMessage);
        return;
      }

      //  422 — Invalid email format or verification failed
      if (statusCode === 422) {
        let serverMessage = "Invalid Email Address";

        try {
          // Sometimes the backend may return stringified JSON in message
          const parsed =
            typeof response.message === "string"
              ? JSON.parse(response.message)
              : null;
          serverMessage = parsed?.message || serverMessage;
        } catch (err) {
          console.error("422 parse error:", err);
        }

        showErrorToast(serverMessage);
        return;
      }

      // ❌ 500 — Server error
      if (statusCode === 500) {
        let serverErrorMessage = "Server error. Please try again later.";

        try {
          const parsedMessage =
            typeof response.message === "string"
              ? JSON.parse(response.message)
              : null;
          if (parsedMessage?.message)
            serverErrorMessage = parsedMessage.message;
        } catch (err) {
          console.error("500 parse error:", err);
        }

        showErrorToast(serverErrorMessage);
        return;
      }

      // ✅ 200 — Success
      if (statusCode === 200) {
        showSuccessToast(
          response?.status?.message || "Email verified successfully",
        );
        setIsEmailVerify(true);
        setIdentifier(response?.identifier);
        setModalOpenEmail(true);
        getProfile();
        return;
      }

      // ⚠️ Fallback
      showWarningToast("Unexpected response from server");
    } catch (error) {
      console.error("Email verification error:", error);
      showErrorToast("Failed to verify Email");
    } finally {
      setIsEmailVerify(false);
      setIsLoading(false);
    }
  }
  // End

  // Fetch Profile Data that contain all Data
  const getProfile = async () => {
    try {
      const response = await fetchProfile();
      setMobile(response.data.mobile_number || "");
      setAadhar(response.data.aadhar_number || "");
      setEmail(response.data.email_address || "");
      setProfileData(response.data || "");
      setWalletBal(response?.data?.balance);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    getProfile();
  }, []);
  // ENd

  useEffect(() => {
    if (profileData) {
      setWalletBal(false); // ensure balance is hidden initially
    }
  }, [profileData]);

  const items = [
    { title: "Recharge", amount: "Rs. 0.00", Icon: MdOutlinePayment },
    { title: "BBPS", amount: "Rs. 0.00", Icon: FiPhone },
    { title: "Pan Verification", amount: "Rs. 0.00", Icon: FiPhone },
    { title: "Aadhar Verification", amount: "Rs. 0.00", Icon: FiPhone },
    { title: "Credit Score", amount: "Rs. 0.00", Icon: FiPhone },
    { title: "Mobile", amount: "Rs. 0.00", Icon: FiPhone },
    { title: "UPI", amount: "Rs. 0.00", Icon: AiFillBank },
    { title: "Payout", amount: "Rs. 0.00", Icon: FiPhone },
  ];

  return (
    <>
      <Seo />

      <ModalWithPinInput
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        title={`Enter OTP to Verify Aadhar  ****** ${aadhar?.substring(8, 12)}`}
        clientID={clientID}
        onLoadReport={getProfile}
      />
      <ModalWithPinInputEmail
        isModalOpen={isModalOpenEmail}
        toggleModalEmail={toggleModalEmail}
        title={`Enter OTP to Verify Email  ****** ${email?.substring(0, 4)}`}
        identifier={identifier}
        onLoadReport={getProfile}
      />
      <ModalWithPinInputMobile
        isModalOpenMobile={isModalOpenMobile}
        toggleModalMobile={toggleModalMobile}
        onLoadReport={getProfile}
        title={`Enter OTP to Verify Mobile no. ****** ${mobile?.substring(6, 10)}`}
        identifier={identifier}
      />

      <Header
        heading={
          profileData || profileData?.company_details ? (
            <>
              <span className="font-semibold">Welcome, </span>{" "}
              <span className=" font-extrabold">
                {profileData?.company_details?.company_name || profileData?.name}
              </span>
            </>
          ) : (
            "Loading..."
          )
        }
      />
      {/* <div className='position relative '>
<FcPrevious    className="block md:hidden position relative text-2xl text-white top-[10%]"/>
    </div>

<div className='position relative ml-[17rem] '>
<FcNext   className="block md:hidden position relative text-2xl text-white top-[10%]"/>
    </div> */}

      {/* <div className='flex justify-content-between'>
  <div className='flex justify-items-start'>
  <FcPrevious  className='text-2xl'/>
  </div>
  <div className='flex justify-items-end'>
  <FcNext  className='text-2xl'/>
    </div>
</div> */}

      <div className="overflow-x-auto md:overflow-x-visible">
        <div
          className="flex md:grid md:grid-cols-1 lg:grid-cols-4 gap-6 px-2 md:px-0"
          data-aos="fade-down"
        >
          {/* <div className="min-w-[300px] md:min-w-0">
      <AnimateCard  
        title="IDSPay Business Wallet"
        text="938547633478"
        text2="IDFC82673"
        buttonview="View Statement"
        checkbal="Check Balance"
      />
    </div> */}

          <div className="w-full group overflow-hidden bg-gradient-to-tr from-blue-500 via-blue-900 to-blue-700 rounded-xl text-white relative shadow-lg">
            <div className="before:duration-700 before:absolute before:w-28 before:h-28 before:bg-transparent before:border-8 before:rounded-full before:opacity-30 before:-left-4 before:-top-12 group-hover:before:top-24 group-hover:before:left-36 group-hover:before:scale-125 group-hover:before:blur"></div>
            <div className="relative z-10 p-2 flex flex-col items-center text-center gap-2">
              <h3 className="text-xl font-bold">Business Wallet</h3>
              <p className="text-sm font-medium opacity-80">IFSC:</p>
              <p className="text-lg font-semibold tracking-wider">
                Account: {profileData?.user_id}
              </p>

              <div className="flex items-center gap-2 mt-2">
                <button
                  onClick={() => setWalletBal(!walletbal)}
                  className="text-2xl hover:text-yellow-300 transition"
                  title={walletbal ? "Hide Balance" : "Show Balance"}
                >
                  {walletbal ? <LuEye size={20} /> : <LuEyeOff size={20} />}
                </button>
                <span className="text-lg font-semibold">
                  {walletbal ? formattedwalletbal : "••••••"}
                </span>
              </div>

              <div className="flex justify-between w-full mt-2 px-2">
                <button className="flex items-center gap-1 text-sm font-semibold border-b border-white hover:text-blue-300 transition">
                  <FaReceipt />
                  <Link to="/BusinessWalletStructure" className="text-white">
                    Wallet History
                  </Link>
                </button>
                <button className="flex items-center gap-1 text-sm font-semibold border-b border-white hover:text-blue-300 transition">
                  <button
                    onClick={() => setWalletBal(!walletbal)}
                    className="text-2xl hover:text-yellow-300 transition"
                    title={walletbal ? "Hide Balance" : "Show Balance"}
                  >
                    {walletbal ? <LuEye size={20} /> : <LuEyeOff size={20} />}
                  </button>
                  <span className="text-md font-semibold">
                    {walletbal ? formattedwalletbal : "Check Balance"}
                  </span>
                </button>
              </div>
            </div>

            {/* 🔧 Add animation if not using Tailwind config */}
            <style>
              {`
      @keyframes scrollUp {
        0% {
          transform: translateY(8px);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
      .animate-scrollUp {
        animation: scrollUp 0.5s ease-out;
      }
    `}
            </style>
          </div>

          <div className="min-w-[300px] md:min-w-0">
            <AnimateCard
              title="Collection Account"
              text="386735634287"
              text2="SBIC83475"
              buttonview="View Statement"
              checkbal="Check Balance"
            />
          </div>

          <div className="w-full group overflow-hidden bg-gradient-to-tr from-blue-500 via-blue-900 to-blue-700 rounded-xl text-white relative shadow-lg">
            {/* 🔴 NEW badge at top-right */}
            <span className="absolute top-2 -right-1  bg-red-600 text-white text-xs font-bold px-1 py-0.5 rounded-md shadow animate-scrollUp rotate-45">
              NEW
            </span>

            {/* 💫 Animated Glow Circle */}
            <div className="before:duration-700 before:absolute before:w-28 before:h-28 before:bg-transparent before:border-8 before:rounded-full before:opacity-30 before:-left-4 before:-top-12 group-hover:before:top-24 group-hover:before:left-36 group-hover:before:scale-125 group-hover:before:blur"></div>

            {/* Content */}
            <div className="relative z-10 p-2 flex flex-col items-center text-center gap-2">
              <h3 className="text-2xl font-bold">Payout Account</h3>
              <p className="text-sm font-medium opacity-80">IFSC: {ifsc}</p>
              <p className="text-lg font-semibold tracking-wider">
                Account: {accountNumber}
              </p>

              <div className="flex items-center gap-2 mt-2">
                <button
                  onClick={() => setShowBalance(!showBalance)}
                  className="text-2xl hover:text-yellow-300 transition"
                  title={showBalance ? "Hide Balance" : "Show Balance"}
                >
                  {showBalance ? <LuEye size={20} /> : <LuEyeOff size={20} />}
                </button>
                <span className="text-lg font-semibold">
                  {showBalance ? formattedBalance : "••••••"}
                </span>
              </div>

              <div className="flex justify-between w-full mt-2 px-2">
                <button className="flex items-center gap-1 text-sm font-semibold border-b border-white hover:text-blue-300 transition">
                  <FaReceipt />
                  <Link to="/payout/report" className="text-white">
                    Payout Report
                  </Link>
                </button>
                <button className="flex items-center gap-1 text-sm font-semibold border-b border-white hover:text-blue-300 transition">
                  <button
                    onClick={() => setShowBalance(!showBalance)}
                    className="text-2xl hover:text-yellow-300 transition"
                    title={showBalance ? "Hide Balance" : "Show Balance"}
                  >
                    {showBalance ? <LuEye size={20} /> : <LuEyeOff size={20} />}
                  </button>
                  <span
                    className="text-md font-semibold"
                    onClick={() => setShowBalance(!showBalance)}
                  >
                    {showBalance ? formattedBalance : "Check Balance"}
                  </span>
                  {/* <button
        onClick={() => setShowBalNew(!showBalNew)}
        className="text-2xl hover:text-yellow-300 transition"
        title={showBalNew ? "Hide Balance" : "Show Balance"}
      >
        {showBalNew ? <LuEye  size={20}/> : <LuEyeOff size={20} />}
      </button>
      <span className="text-md font-semibold">
        {showBalNew ? formattedBalance : "Check Balance"}
      </span> */}
                </button>
              </div>
            </div>

            {/* 🔧 Add animation if not using Tailwind config */}
            <style>
              {`
      @keyframes scrollUp {
        0% {
          transform: translateY(8px);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
      .animate-scrollUp {
        animation: scrollUp 0.5s ease-out;
      }
    `}
            </style>
          </div>

          <div className="min-w-[300px] md:min-w-0">
            <div
              className="w-full h-48 md:h-full group overflow-hidden bg-black rounded-xl bg-gradient-to-tr from-blue-500 via-blue-900 to-blue-700 text-gray-50 relative bg-cover bg-center"
              style={{
                backgroundImage: "url('assets/images/HighMark.jpg')",
              }}
            />
          </div>
        </div>
      </div>

      <div className="dashboard my-3 flex gap-2 flex-wrap">
        <div className="flex flex-col lg:flex-row gap-2 w-full">
          <div
            className="box_shadow_box flex flex-col p-2 items-center justify-center lg:w-96"
            data-aos="fade-left"
          >
            <img
              loading="lazy"
              className="border_bottom"
              src={
                process.env.PUBLIC_URL +
                "/media/dashboard_img/employee_talking.png"
              }
              alt=""
            />
            <h1 className="text-center font-bold text-2xl my-2 text-gray-600">
              Business Banking Summary
            </h1>
            <div className="flex gap-3">
              <div className="box_without_box_shadow rounded-md m-2 flex flex-col p-2 bg-box-1">
                <GiCash />
                <h1>AePS Withdrawal</h1>
                <h1>
                  <strong className="text-2xl">₹ 0.00</strong>
                </h1>
              </div>
              <div className="box_without_box_shadow rounded-md m-2 flex flex-col p-2 bg-box-2">
                <GiCash />
                <h1>M-ATM Withdrawal</h1>
                <h1>
                  <strong className=" text-2xl">₹ 0.00</strong>
                </h1>
              </div>
            </div>
            <div className="flex gap-3">
              <div className="box_without_box_shadow rounded-md m-2 flex flex-col p-2 bg-box-3">
                <GiCash />
                <h1>DMT</h1>
                <h1>
                  <strong className=" text-2xl">₹ 0.00</strong>
                </h1>
              </div>
              <div className="box_without_box_shadow rounded-md m-2 flex flex-col p-2 bg-box-4">
                <GiCash />
                <h1>AEPS Settlement</h1>
                <h1>
                  <strong className=" text-2xl">₹ 0.00</strong>
                </h1>
              </div>
            </div>
          </div>
          <div
            className="txn_summary box_shadow_box p-2 flex-1"
            data-aos="fade-right"
          >
            <div className="flex justify-between items-center">
              <h1 className="font-bold text-2xl my-2 text-gray-600 text-nowrap">
                Transaction Summary
              </h1>
            </div>
            <hr />
            <div className="flex justify-between items-center">
              <ul className="justify-center items-center  w-1/2">
                <li className="flex items-center my-5 border-b-2 border-bottom border-b-yellow-500">
                  <span className="dot bg-yellow-500 h-3 w-3 rounded-full mr-2"></span>
                  <div className="flex flex-col">
                    <strong className="text-gray-600">Payout Pending </strong>
                    <p className="text-gray-500">₹ 0.00</p>
                  </div>
                </li>
                <li className="flex items-center my-5 border-b-2 border-bottom border-b-green-500">
                  <span className="dot bg-green-500 h-3 w-3 rounded-full mr-2"></span>
                  <div className="flex flex-col">
                    <strong className="text-gray-600">Payout Success </strong>
                    <p className="text-gray-500">₹ 0.00</p>
                  </div>
                </li>
                <li className="flex items-center my-5 border-b-2 border-b-red-500">
                  <span className="dot bg-red-500 h-3 w-3 rounded-full mr-2"></span>
                  <div className="flex flex-col">
                    <strong className="text-gray-600">Payout Failed </strong>
                    <p className="text-gray-500">₹ 0.00</p>
                  </div>
                </li>
                <li className="flex items-center my-5 border-b-2 border-b-blue-900">
                  <span className="dot bg-blue-900 h-3 w-3 rounded-full mr-2"></span>
                  <div className="flex flex-col">
                    <strong className="text-gray-600">Van Collection </strong>
                    <p className="text-gray-500">₹ 0.00</p>
                  </div>
                </li>
                <li className="flex items-center my-5 border-b-2 border-b-blue-500">
                  <span className="dot bg-blue-500 h-3 w-3 rounded-full mr-2"></span>
                  <div className="flex flex-col">
                    <strong className="text-gray-600">QR Collection </strong>
                    <p id="new_god" className="text-gray-500">
                      ₹ 0.00
                    </p>
                  </div>
                </li>
              </ul>
              <div className="flex justify-around items-center flex-col min-h-80">
                <select
                  name="which_day"
                  className="ml-3 border outline-none rounded"
                  id="which_day"
                >
                  <option value="Today">Today</option>
                  <option value="Yesterday">Yesterday</option>
                  <option value="This Month">This Month</option>
                  <option value="This Year">This Year</option>
                </select>
                <PieChart
                  style={{ height: "180px", width: "180px" }}
                  animate
                  animationDuration={2000}
                  animationEasing="ease-out"
                  data={[
                    { title: "Payout Pending", value: 5000, color: "#eab308" },
                    { title: "Payout Success", value: 10000, color: "#22c55e" },
                    { title: "Payout Failed", value: 15000, color: "#ef4444" },
                    { title: "Money In", value: 1000, color: "#1e3a8a" },
                    { title: "Money Out", value: 20000, color: "#3b82f6" },
                  ]}
                />
              </div>
            </div>
          </div>
          <div
            className="box_shadow flex-1 card shadow-md p-2 rounded-sm"
            data-aos="zoom-in"
          >
            <h1 className="font-bold text-2xl my-2 text-gray-600 text-nowrap px-5">
              New Launch
            </h1>
            <hr />
            <SliderCrousel />
          </div>
        </div>

        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch justify-items-stretch justify-between py-10">
          {/* important instructions */}
          <div className="w-full ">
            <div className="relative w-full">
              {/* CARD */}
              <div className="relative rounded-3xl overflow-hidden shadow-[0_30px_80px_-15px_rgba(0,0,0,0.6)]">
                {/* HEADER STRIP */}
                <div className="bg-gradient-to-br from-purple-700 via-indigo-700 to-blue-600 px-6 py-4 flex items-center gap-3">
                  <div className="h-11 w-11 rounded-full bg-black/30 backdrop-blur flex items-center justify-center">
                    <InfoIcon className="h-6 w-6 text-white " />
                  </div>
                  <h2 className="text-white text-xl font-extrabold tracking-widest uppercase">
                    Important Instructions
                  </h2>
                </div>

                {/* BODY */}
                <div className="bg-gradient-to-br from-[#dcdddf] via-[#c7c8c7] to-gray-200 px-6 py-6 text-black">
                  <ul className="space-y-2 text-sm">
                    <li className="flex gap-3 items-center">
                      <span className="h-2.5 w-2.5 rounded-full bg-purple-700 " />
                      <p className="text-lg">
                        <b className="text-purple-700">API Account & KYC</b>{" "}
                        must be approved.
                      </p>
                    </li>

                    <li className="flex gap-3 items-center">
                      <span className="h-2.5 w-2.5 mt-1 rounded-full bg-purple-700 " />
                      <p className="text-lg">
                        <b className="text-purple-700">Server IP</b> must be
                        whitelisted from IP Whitelist menu.
                      </p>
                    </li>

                    <li className="flex gap-3 items-center">
                      <span className="h-2.5 w-2.5 mt-1 rounded-full bg-purple-700 " />
                      <p className="text-lg">
                        <b className="text-purple-700">API Service</b> should be
                        enabled in
                        <span className="text-purple-700 font-semibold">
                          {" "}
                          Production
                        </span>{" "}
                        or
                        <span className="text-purple-700 font-semibold">
                          {" "}
                          UAT
                        </span>
                        .
                      </p>
                    </li>

                    <li className="flex gap-3 items-center">
                      <span className="h-2.5 w-2.5 mt-1 rounded-full bg-purple-700 " />
                      <p className="text-lg">
                        <b className="text-purple-700">Production</b> returns
                        actual API response.
                      </p>
                    </li>

                    <li className="flex gap-3 items-center">
                      <span className="h-2.5 w-2.5 mt-1 rounded-full bg-purple-700 " />
                      <p className="text-lg">
                        <b className="text-purple-700">UAT</b> provides sample
                        response only.
                      </p>
                    </li>
                  </ul>
                </div>

                {/* FOOTER STRIP */}
                <div className="bg-gradient-to-r from-indigo-600 via-purple-500 to-blue-500 h-1" />
              </div>
            </div>
          </div>

          <div className="relative bg-gradient-to-br from-[#dcdddf] via-[#c7c8c7] to-gray-200 flex flex-col justify-between rounded-3xl overflow-hidden">
            <div className="relative ">
              {/* digital kyc */}
              <div
                className=" shadow-md rounded-md w-full"
                data-aos="flip-right"
              >
                {/* HEADER STRIP */}
                <div className="bg-gradient-to-br from-purple-700 via-indigo-700 to-blue-600 px-6 py-4 flex items-center gap-3">
                  <div className="h-11 w-11 rounded-full bg-black/30 backdrop-blur flex items-center justify-center">
                    <User2Icon className="h-6 w-6 text-white " />
                  </div>
                  <h2 className="text-white text-xl font-extrabold tracking-widest uppercase">
                    Digital Kyc Status
                  </h2>
                </div>
                <hr />
                <div className="flex justify-center">
                  <HiArrowsRightLeft className="block md:hidden text-2xl" />
                </div>
                <div className="overflow-x-auto px-2 md:overflow-x-visible">
                  <div
                    className="flex md:grid md:grid-cols-1 lg:grid-cols-4 gap-6 px-2 md:px-0"
                    data-aos="fade-down"
                  >
                    <div className="min-w-[300px] md:min-w-0">
                      <div className="standard-box-shadow w-full flex flex-col items-center justify-center bg-gray-200 rounded-md mt-2 box__ p-3">
                        <div className="flex justify-between mb-3">
                          <div className="left_icon bg-gray-200 p-2 rounded-full">
                            <img
                              loading="lazy"
                              className="w-10 h-8"
                              src="assets/images/aadhar.png"
                              alt="aadhar"
                            />
                          </div>
                        </div>
                        <p className="text-xl mt-3 mb-2 font-bold">Aadhar</p>
                        {profileData && profileData?.aadhar_number ? (
                          profileData?.aadhar_verified_at !== null &&
                          profileData?.aadhar_number?.length === 12 ? (
                            <p className="text-green-500 mt-6 font-bold text-xl">
                              Verified
                            </p>
                          ) : profileData?.aadhar_number?.length !== 12 ? (
                            <p className="text-red-500 mt-6 font-bold text-md">
                              Invalid Aadhar number
                            </p>
                          ) : (
                            <button
                              onClick={validateAadhar}
                              className={
                                isAadharVerify
                                  ? "opacity-50 cursor-not-allowed mt-4 bg-green-800 hover:bg-blue-700 hover:text-white  text-white rounded-md p-1"
                                  : "bg-green-800 hover:bg-blue-700 hover:text-white   text-white rounded-md p-1 mt-4"
                              }
                              disabled={isAadharVerify}
                            >
                              {isAadharVerify ? "Validating..." : "Validate"}
                            </button>
                          )
                        ) : (
                          <p className="text-red-500 mt-6 font-bold text-md">
                            Adhar number is missing
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="min-w-[300px] h-full md:min-w-0">
                      <div className="standard-box-shadow w-full  flex flex-col items-center justify-center bg-gray-200 rounded-md mt-2 box__ p-3">
                        <div className="flex justify-between mb-3">
                          <div className="left_icon bg-gray-200 p-2 rounded-full">
                            <img
                              loading="lazy"
                              className="w-10 h-8"
                              src="assets/images/Pan.png"
                              alt="pan"
                            />
                          </div>
                        </div>
                        <p className="text-xl mt-3 mb-2 font-bold">Pan</p>
                        {profileData.length > 0 ||
                        profileData.pan_verified_at !== null ? (
                          <p className="text-green-500 mt-6 font-bold text-xl">
                            Verified
                          </p>
                        ) : (
                          <button
                            onClick={validatePan}
                            className={
                              isPanVerify
                                ? "opacity-50 cursor-not-allowed mt-4 bg-green-800 hover:bg-blue-700 hover:text-white text-white rounded-md p-1"
                                : "bg-green-800 hover:bg-blue-700 hover:text-white  text-white rounded-md mt-4 p-1"
                            }
                            disabled={isPanVerify}
                          >
                            {isPanVerify ? "Validating..." : "Validate"}
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="min-w-[300px] md:min-w-0">
                      <div className="standard-box-shadow flex flex-col items-center justify-center w-full bg-gray-200 rounded-md mt-2 box__ p-3">
                        <div className="flex justify-between mb-3">
                          <div className="left_icon bg-gray-200 p-2 rounded-full">
                            <img
                              loading="lazy"
                              className="w-10 h-8"
                              src="assets/images/email.png"
                              alt="email"
                            />
                          </div>
                        </div>
                        <p className="text-xl mt-3 mb-2 font-bold">Email</p>
                        {profileData?.length > 0 ||
                        profileData.email_verified_at !== null ? (
                          <p className="text-green-500 mt-6 font-bold text-xl">
                            Verified
                          </p>
                        ) : (
                          <button
                            onClick={validateEmail}
                            className={
                              isEmailVerify
                                ? "opacity-50 cursor-not-allowed bg-green-800 mt-4 hover:bg-blue-700 hover:text-white text-white rounded-md p-1"
                                : "bg-green-800 hover:bg-blue-700 hover:text-white  text-white rounded-md mt-4 p-1"
                            }
                          >
                            {isEmailVerify ? "Validating..." : "Validate"}
                          </button>
                        )}
                        {/* {profileData.email_address} */}
                      </div>
                    </div>

                    <div className="min-w-[300px] md:min-w-0">
                      <div className="standard-box-shadow flex flex-col items-center justify-center bg-gray-200 w-full rounded-md mt-2 box__ p-3">
                        <div className="flex justify-between mb-3">
                          <div className="left_icon bg-gray-200 p-2 rounded-full">
                            <img
                              loading="lazy"
                              className="w-10 h-8"
                              src="assets/images/mobile.png"
                              alt="mobile"
                            />
                          </div>
                        </div>
                        <p className="text-xl mt-3 mb-2 font-bold">Mobile</p>
                        {profileData && profileData?.mobile_number ? (
                          profileData?.mobile_verified_at !== null &&
                          profileData?.mobile_number?.length === 10 ? (
                            <p className="text-green-500 mt-6 font-bold text-xl">
                              Verified
                            </p>
                          ) : profileData?.mobile_number?.length !== 10 ? (
                            <p className="text-red-500 mt-6 font-bold text-md">
                              Invalid mobile number
                            </p>
                          ) : (
                            <button
                              onClick={validateMobile}
                              className={
                                isMobileVerify
                                  ? "opacity-50 cursor-not-allowed mt-4 bg-green-800 hover:bg-blue-700 hover:text-white text-white rounded-md p-1"
                                  : "bg-green-800 hover:bg-blue-700 hover:text-white text-white rounded-md mt-4 p-1"
                              }
                              disabled={isMobileVerify}
                            >
                              {isMobileVerify ? "Validating..." : "Validate"}
                            </button>
                          )
                        ) : (
                          <p className="text-red-500 mt-6 font-bold text-md">
                            Mobile number is missing
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-r from-indigo-600 via-purple-500 to-blue-500 h-1" />
          </div>
        </div>

        {/* <div
      className="card shadow-md p-2 rounded-lg w-full bg-white"
      data-aos="flip-left"
    >
      <h1 className="font-extrabold text-3xl text-gray-700 mb-2 px-1 whitespace-nowrap">
        Summary
      </h1>
      <hr className="mb-5" />

      <div className="flex space-x-2 overflow-x-auto scrollbar-thin scrollbar-thumb-blue-600 scrollbar-track-blue-100 sm:grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
        {items.map(({ title, amount, Icon }, idx) => (
          <div
            key={idx}
            className="flex-shrink-0 w-64 rounded-lg shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition duration-300 ease-in-out bg-gradient-to-tr from-blue-900 to-blue-700 text-white flex items-center"
          >
            <div className="p-3 flex items-center justify-center">
              <Icon size={32} className="text-white" />
            </div>
            <div className="p-2 flex flex-col justify-center w-full">
              <h2 className="font-bold text-xl">{title}</h2>
              <p className="text-gray-300 font-semibold mt-1">{amount}</p>
            </div>
          </div>
        ))}
      </div>
    </div> */}
      </div>
    </>
  );
}
